module.exports = __webpack_public_path__ + "static/media/bc_green.71b96422.png";